<template>
  <div id="habitationFormQuote">
        <SimpleStepperHabitation></SimpleStepperHabitation>
  </div>
</template>

<script>
import SimpleStepperHabitation from "./views/assurances/SimpleStepperHabitation.vue"
import Buefy from "buefy";
import Vue from "vue";

//import { FadeTransition } from "vue2-transitions";

Vue.use(Buefy, {
  defaultIconPack: "fas",
  defaultContainerElement: "#content",
});
export default {
  name: "App",
  components: {
    SimpleStepperHabitation,
  },
};
</script>
<style scoped>
.section-shaped .shape {
  z-index: unset !important;
}
</style>